var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"required-text"},[_c('span',[_vm._v("*")]),_vm._v("\n  Required information\n")])}]

export { render, staticRenderFns }